import React, { useState, useEffect } from "react";
import { useCheckAccess } from "../../utils/Utilities";
import { queryCategoryConfig } from "../../service/UtilApi";
import { Loading } from "../../components/shared"; // Assuming this component is the spinning icon
import '../general/General.css'; // Assuming the styles for the spinner are in this file

const CategoryList = () => {
    useCheckAccess('ConfigRW');
    const [categories, setCategories] = useState([]);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false); // Add loading state

    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true); // Set loading to true when the request is starting
            try {
                const response = await queryCategoryConfig();
                // Correct the check here to use `categoriesList` from the response
                if (!response || !response.categoriesList || response.categoriesList.length === 0) {
                    setMessage("No categories found.");
                    setCategories([]);
                } else {
                    setCategories(response.categoriesList); // Set the categories correctly
                }
            } catch (error) {
                setMessage("Error fetching categories and subcategories.");
            } finally {
                setLoading(false); // Set loading to false after the request is complete
            }
        };

        fetchCategories();
    }, []);



    if (loading) {
        return (
            <div className="general_body">
                <Loading />
            </div>
        );
    }

    return (
        <div className="general_parent">
            <div className="general_container">
                <div className="general_body">
                    <h2>Categories and Subcategories</h2>
                    <br />

                    {/* Show loading spinner while fetching categories */}


                    {message && <p>{message}</p>}

                    {/* Display categories if they are available */}
                    {categories.length === 0 ? (
                        <p>No categories found.</p>
                    ) : (
                        <ul>
                            {categories.map((category) => (
                                <li key={category.categoryName}>
                                    <h3>Category: {category.categoryName} ({category.description})</h3>

                                    <br />
                                    <h4>Subcategories:</h4>
                                    {Array.isArray(category.subcategories) && category.subcategories.length > 0 ? (
                                        <>
                                            <ul>
                                                {category.subcategories.map((subcategory) => (
                                                    <li key={subcategory.name}>
                                                        <strong>{subcategory.name}</strong> ({subcategory.description}) <strong>uniqueOption: </strong> {(subcategory.uniqueOption || "")} <strong>amount: </strong>{(subcategory.amount || "")}
                                                    </li>
                                                ))}
                                            </ul>
                                            <br />
                                        </>
                                    ) : (
                                        <p>No subcategories available</p>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CategoryList;
